import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';

// Components.
import AuthClearContainer from 'containers/AuthClearContainer';

// Actions.
import * as ProfileActions from 'actions/ProfileActions';
import * as ConfigActions from 'actions/ConfigActions';

// Config.
import { serviceUserToken, facebookId } from 'config/index'

@connect(
  state => ({
    auth: state.auth,
    profile: state.profile,
    config: state.config,
    i18n: state.i18n,
  }),
  dispatch => ({
    profileActions: bindActionCreators(ProfileActions, dispatch),
    configActions: bindActionCreators(ConfigActions, dispatch),
  }),
)
export default class AuthRequireContainer extends React.Component {

  static defaultProps = {
    isFree: false,
  };

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const { auth: { isAuthenticated } } = this.props;
    if (!isAuthenticated) {
      axios.defaults.headers.common['Authorization'] = `Token ${serviceUserToken}`;
    }
  }

  componentDidMount() {
    const { auth: { isAuthenticated }, profile, config, i18n } = this.props;
    // Fetch configs.
    if (isAuthenticated && !config.isFetched) {
      this.props.configActions.loadConfig();
    }
    if (isAuthenticated && !profile.isFetched) {
      this.props.profileActions.loadUserProfile();
    }
    const currentThis = this;
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: facebookId,
        xfbml: false,
        version: 'v3.3',
      });
      currentThis.onInitFB();
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js?xfbml=false";
      js.async = true;
      js.defer = true;
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { auth: { isAuthenticated } } = this.props;

    if (isAuthenticated !== nextProps.isAuthenticated && nextProps.isAuthenticated === true && nextProps.config.isFetched === false && nextProps.config.isFetching === false) {
      this.props.configActions.loadConfig();
    }

    if (isAuthenticated !== nextProps.isAuthenticated && nextProps.isAuthenticated === true && nextProps.profile.isFetched === false && nextProps.profile.isFetching === false) {
      this.props.profileActions.loadUserProfile();
    }
  }

  componentWillUnmount() {
    const { auth } = this.props;
    if (!auth.isAuthenticated) {
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  onInitFB = () => {
  };

  render() {
    const {
      auth: { isAuthenticated },
      component: Component,
      isFree,
      title,
      additionTitle,
      location,
      ...props
    } = this.props;
    return (
      <Route
        {...props}
        render={props =>
          (isAuthenticated || isFree)
            ? (
                <AuthClearContainer title={title} additionTitle={additionTitle} >
                  <Component />
                </AuthClearContainer>
              )
            : (
            <Redirect to={{
              pathname: '/user/login',
              search: queryString.stringify({ ...queryString.parse(location.search), destination: location.pathname}),
              state: { from: location }
            }} />
          )
        }
      />
    )
  }

}
